import { orange } from "@mui/material/colors";
import ReactECharts from "echarts-for-react";
import { color } from "highcharts";


// This is a stateless reusable component to show the demand capacity graph
// using the echart and provided data and label.
function DemandCapacityGraph({
  demand,
  capacity,
  cu,
  labels,
  labelBg,
  threshold,
  unit,
}) {
  const thresholdValue = threshold || 90;

  const option = {
    grid: {
      top: 30,
      left: 70,
      right: 70,
      bottom: 50,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    legend: {
      data: ["Demand", "Capacity", "CU%"],
      top: "bottom",
      itemWidth: 6,
      itemHeight: 15,
      icon: "rect",
    },

    xAxis: [
      {
        type: "category",
        data: labels,
        axisPointer: {
          type: "shadow",
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            fontSize: 10,
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: unit || "Tonnes",
        nameLocation: "middle",
        nameRotate: 90,
        nameGap: 50,
        splitNumber: 3,
        splitLine: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            fontSize: 10,
          },
        },
      },
      {
        type: "value",
        name: "CU%",
        nameLocation: "middle",
        nameRotate: -90,
        nameGap: 50,
        splitNumber: 3,
        splitLine: {
          show: false,
        },
        axisLabel: {
          formatter: "{value}%",
          textStyle: {
            fontSize: 10,
          },
        },
      },
    ],
    series: [
      {
        name: "Demand",
        type: "bar",
        data: demand,
        itemStyle: {
          color: "#0055ee",
          borderRadius: [3, 3, 0, 0],
        },
        barGap: "25%",
        barCategoryGap: "40%",
      },
      {
        name: "Capacity",
        type: "bar",
        data: capacity,
        itemStyle: {
          color: "#00b190",
          borderRadius: [3, 3, 0, 0],
        },
      },
      {
        name: "CU%",
        type: "line",
        yAxisIndex: 1,
        tooltip: {
          valueFormatter: function (value) {
            return value + "%";
          },
        },
        data: cu,
        itemStyle: {
          color: "#FF9E00",
        },
        lineStyle: {
          color: "#FF9E00",
          width: 1,
        },
        smooth: true,
        symbolSize: 7,
        symbol: "circle",
        label: labelBg
          ? {
              show: true,
              position: "top",
              // backgroundColor: "white",
              offset: [0, -8],
              // padding: [4, 4],
              borderRadius: 4,
              align: "center",
              verticalAlign: "middle",
              formatter: (params) => {
                return params.value >= thresholdValue
                  ? `{red|${params.value + "%"}}`
                  : params.value >= cu && params.value < thresholdValue
                  ? `{orange| ${params.value + "%"}}`
                  : `{green|${params.value + "%"}}`;
              },
              rich: {
                red: {
                  color: "red",
                  fontWeight: "bold",
                },
                orange: {
                  color: "#ffc843",
                  fontWeight: "bold",
                },
                green: {
                  color: "#3ab18f",
                  fontWeight: "bold",
                },
              },
            }
          : { show: true, position: "top", formatter: "{c}%" },
      },
    ],
  };

  return (
    <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
  );
}

export default DemandCapacityGraph;
